import { Box, Button, Flex, HStack, Image, Separator, Stack, Text } from "@chakra-ui/react"
import { Form, UI } from "components"
import { API } from "config"
import { toaster } from "config"
import { useState } from "react"
import { useLocation, useNavigate } from "react-router"

const NetworkSVG = () => (
    <Box position="absolute" inset={0} overflow="hidden" style={{ pointerEvents: 'none' }}>
        <svg
            width="100%"
            height="100%"
            viewBox="0 0 800 900"
            preserveAspectRatio="xMidYMid slice"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g stroke="rgba(251,146,60,0.09)" strokeWidth="1" fill="none">
                <line x1="80" y1="60" x2="170" y2="215" />
                <line x1="280" y1="50" x2="170" y2="215" />
                <line x1="720" y1="70" x2="660" y2="195" />
                <line x1="520" y1="80" x2="660" y2="195" />
                <line x1="75" y1="380" x2="160" y2="510" />
                <line x1="740" y1="445" x2="590" y2="530" />
                <line x1="50" y1="625" x2="160" y2="510" />
                <line x1="50" y1="625" x2="210" y2="705" />
                <line x1="635" y1="670" x2="750" y2="770" />
                <line x1="210" y1="705" x2="100" y2="830" />
                <line x1="420" y1="725" x2="330" y2="860" />
                <line x1="635" y1="670" x2="550" y2="840" />
            </g>
            <g stroke="rgba(251,146,60,0.15)" strokeWidth="1" fill="none">
                <line x1="280" y1="50" x2="400" y2="190" />
                <line x1="520" y1="80" x2="400" y2="190" />
                <line x1="170" y1="215" x2="400" y2="190" />
                <line x1="660" y1="195" x2="620" y2="305" />
                <line x1="400" y1="190" x2="620" y2="305" />
                <line x1="75" y1="380" x2="270" y2="355" />
                <line x1="270" y1="355" x2="400" y2="190" />
                <line x1="270" y1="355" x2="510" y2="400" />
                <line x1="620" y1="305" x2="510" y2="400" />
                <line x1="620" y1="305" x2="740" y2="445" />
                <line x1="510" y1="400" x2="740" y2="445" />
                <line x1="270" y1="355" x2="160" y2="510" />
                <line x1="160" y1="510" x2="370" y2="550" />
                <line x1="590" y1="530" x2="370" y2="550" />
                <line x1="160" y1="510" x2="210" y2="705" />
                <line x1="370" y1="550" x2="420" y2="725" />
                <line x1="210" y1="705" x2="420" y2="725" />
                <line x1="420" y1="725" x2="635" y2="670" />
                <line x1="590" y1="530" x2="635" y2="670" />
            </g>
            <g stroke="rgba(251,146,60,0.22)" strokeWidth="1.2" fill="none">
                <line x1="400" y1="190" x2="510" y2="400" />
                <line x1="510" y1="400" x2="370" y2="550" />
            </g>
            <g fill="rgba(251,146,60,0.28)">
                <circle cx="80" cy="60" r="2.5" />
                <circle cx="280" cy="50" r="2.5" />
                <circle cx="520" cy="80" r="2.5" />
                <circle cx="720" cy="70" r="2.5" />
                <circle cx="660" cy="195" r="2.5" />
                <circle cx="170" cy="215" r="3" />
                <circle cx="620" cy="305" r="3" />
                <circle cx="75" cy="380" r="2.5" />
                <circle cx="270" cy="355" r="3" />
                <circle cx="740" cy="445" r="2.5" />
                <circle cx="160" cy="510" r="3" />
                <circle cx="590" cy="530" r="3" />
                <circle cx="50" cy="625" r="2.5" />
                <circle cx="210" cy="705" r="3" />
                <circle cx="420" cy="725" r="3" />
                <circle cx="635" cy="670" r="2.5" />
                <circle cx="100" cy="830" r="2.5" />
                <circle cx="330" cy="860" r="2.5" />
                <circle cx="550" cy="840" r="2.5" />
                <circle cx="750" cy="770" r="2.5" />
            </g>
            <circle cx="400" cy="190" r="11" fill="none" stroke="rgba(251,146,60,0.14)" strokeWidth="1" />
            <circle cx="400" cy="190" r="5" fill="rgba(251,146,60,0.60)" />
            <circle cx="510" cy="400" r="11" fill="none" stroke="rgba(251,146,60,0.14)" strokeWidth="1" />
            <circle cx="510" cy="400" r="5" fill="rgba(251,146,60,0.60)" />
            <circle cx="370" cy="550" r="11" fill="none" stroke="rgba(251,146,60,0.14)" strokeWidth="1" />
            <circle cx="370" cy="550" r="5" fill="rgba(251,146,60,0.60)" />
        </svg>
    </Box>
)

export default function Reset(){

    const navigate = useNavigate()
    const location = useLocation()
    const params = new URLSearchParams(location.search)
    const [ password, setPassword ] = useState()
    const [ password_retype, setPasswordRetype ] = useState()
    const [ loading, setLoading ] = useState(false)
    const otp_code = params.get('otp_code');
    const email = params.get('email')

    const enabled = password?.length >= 6 && password_retype === password

    const handleSubmit = async () => {
        setLoading(true)

        try{
            await API.put('/recovery', { otp_code, password, email })
            toaster.create({ title: 'Sua senha foi redefinida', description: 'Faça login para continuar', type: 'success' })
            navigate('/')
        }catch(err){
            toaster.create({ title: 'Não foi possível atualizar a senha.', description: err?.response?.data?.message, type: 'warning'})
            setLoading(false)
        }
    }

    return(
    <Flex h="100vh" overflow="hidden">

        {/* ── Painel esquerdo ── */}
        <Flex
            hideBelow="lg"
            flex="1"
            direction="column"
            align="center"
            justify="center"
            position="relative"
            overflow="hidden"
            style={{
                background: 'radial-gradient(ellipse at 75% 8%, rgba(251,146,60,0.20) 0%, transparent 52%), radial-gradient(ellipse at 8% 92%, rgba(99,102,241,0.14) 0%, transparent 46%), linear-gradient(155deg, #070c17 0%, #0d1525 50%, #0a1628 100%)'
            }}
            p={14}
        >
            <NetworkSVG />

            <Box
                position="absolute"
                top="6%"
                right="-50px"
                w="360px"
                h="360px"
                borderRadius="full"
                style={{ background: 'radial-gradient(circle, rgba(251,146,60,0.09) 0%, transparent 70%)', pointerEvents: 'none' }}
            />
            <Box
                position="absolute"
                bottom="-70px"
                left="-30px"
                w="300px"
                h="300px"
                borderRadius="full"
                style={{ background: 'radial-gradient(circle, rgba(99,102,241,0.08) 0%, transparent 70%)', pointerEvents: 'none' }}
            />

            <Stack gap={10} zIndex={1} w="100%" maxW="380px">

                <Stack gap={5}>
                    <HStack gap={4}>
                        <Box
                            p="10px"
                            borderRadius={14}
                            style={{
                                background: 'rgba(255,255,255,0.07)',
                                border: '1px solid rgba(255,255,255,0.12)',
                                backdropFilter: 'blur(8px)'
                            }}
                        >
                            <Image src="/icon.png" h="44px" />
                        </Box>
                        <Box>
                            <Text color="white" fontWeight="bold" fontSize="2xl" lineHeight="1" letterSpacing="-0.01em">Bonífica</Text>
                            <Box mt="6px" display="inline-flex">
                                <Box
                                    px={3}
                                    py="3px"
                                    borderRadius="full"
                                    style={{
                                        background: 'rgba(251,146,60,0.15)',
                                        border: '1px solid rgba(251,146,60,0.30)'
                                    }}
                                >
                                    <Text color="orange.300" fontSize="xs" fontWeight="medium">Escritório de Consultor</Text>
                                </Box>
                            </Box>
                        </Box>
                    </HStack>

                    <Box>
                        <Text
                            color="white"
                            fontSize="2xl"
                            fontWeight="bold"
                            lineHeight="1.25"
                            letterSpacing="-0.02em"
                        >
                            Criar nova<br />senha de acesso
                        </Text>
                        <Text
                            mt={3}
                            fontSize="sm"
                            lineHeight="1.7"
                            style={{ color: 'rgba(255,255,255,0.48)' }}
                        >
                            Escolha uma senha segura para proteger o acesso ao seu escritório.
                        </Text>
                    </Box>
                </Stack>

                <Stack gap={3}>
                    {[
                        { icon: 'key', title: 'Mínimo de 6 caracteres', desc: 'Use letras, números e símbolos para maior segurança' },
                        { icon: 'check', title: 'Confirme a nova senha', desc: 'Os dois campos precisam ser idênticos' },
                        { icon: 'identity', title: 'Acesso vinculado ao e-mail', desc: 'Sua nova senha ficará associada à conta' },
                    ].map(({ icon, title, desc }) => (
                        <HStack
                            key={title}
                            gap={4}
                            p={4}
                            borderRadius={12}
                            style={{
                                background: 'rgba(255,255,255,0.04)',
                                border: '1px solid rgba(255,255,255,0.07)'
                            }}
                        >
                            <Box
                                p="8px"
                                borderRadius={8}
                                flexShrink={0}
                                style={{ background: 'rgba(251,146,60,0.15)' }}
                            >
                                <UI.Icon name={icon} color="orange.300" boxSize={4} />
                            </Box>
                            <Box>
                                <Text color="white" fontSize="sm" fontWeight="semibold" lineHeight="1.2">{title}</Text>
                                <Text fontSize="xs" mt="3px" lineHeight="1.4" style={{ color: 'rgba(255,255,255,0.42)' }}>{desc}</Text>
                            </Box>
                        </HStack>
                    ))}
                </Stack>

            </Stack>
        </Flex>

        {/* ── Painel direito ── */}
        <Flex
            flex={{ base: 1, lg: '0 0 480px' }}
            direction="column"
            align="center"
            justify="center"
            p={8}
            bg="bg"
            position="relative"
        >
            <Box
                position="absolute"
                top={0}
                left={0}
                right={0}
                h="3px"
                style={{ background: 'linear-gradient(90deg, transparent 0%, rgba(251,146,60,0.7) 50%, transparent 100%)' }}
            />

            <Stack gap={7} w="100%" maxW="380px">

                <HStack hideFrom="lg" gap={3} justify="center">
                    <Image src="/icon.png" h="36px" />
                    <Box>
                        <Text fontWeight="bold" fontSize="lg">Bonífica</Text>
                        <Text fontSize="xs" color="fg.muted">Escritório de Consultor</Text>
                    </Box>
                </HStack>

                <Box>
                    <Text fontSize="2xl" fontWeight="bold" letterSpacing="-0.02em">Nova senha</Text>
                    <Text color="fg.muted" fontSize="sm" mt={1}>Crie uma nova senha para sua conta</Text>
                </Box>

                <Form.Container onSubmit={handleSubmit}>
                    <Form.Text
                        disabled
                        label="E-mail"
                        type="email"
                        value={email}
                    />
                    <Form.Password
                        required
                        autoFocus
                        label="Nova senha"
                        placeholder="••••••••"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        disabled={loading}
                        helper="Sua senha precisa ter no mínimo 6 caracteres."
                    />
                    <Form.Password
                        required
                        label="Confirme a nova senha"
                        placeholder="••••••••"
                        value={password_retype}
                        onChange={e => setPasswordRetype(e.target.value)}
                        disabled={loading}
                    />
                    <Button
                        type="submit"
                        w="100%"
                        size="lg"
                        colorPalette="orange"
                        disabled={!enabled}
                        loading={loading}
                        loadingText="Atualizando..."
                    >
                        <UI.Icon name="key" /> Alterar senha
                    </Button>
                </Form.Container>

                <HStack gap={3}>
                    <Separator flex="1" />
                    <Text fontSize="xs" color="fg.subtle">ou</Text>
                    <Separator flex="1" />
                </HStack>

                <Button w="100%" size="lg" variant="ghost" onClick={() => navigate('/')} disabled={loading}>
                    <UI.Icon name="prev" /> Voltar para o login
                </Button>

            </Stack>
        </Flex>

    </Flex>
    )
}
